import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=07fca59b&scoped=true&"
import script from "./Budgets.vue?vue&type=script&lang=js&"
export * from "./Budgets.vue?vue&type=script&lang=js&"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=07fca59b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fca59b",
  null
  
)

export default component.exports